/* eslint-env browser */
function fetchCallback(url, callback, options = {}) {
  const {
    method = 'get',
  } = options
  const request = new XMLHttpRequest()
  request.open(method, url, true)

  request.onload = () => {
    callback(null, response())
  }

  request.onerror = () => {
    callback(`Could not load the resource at ${url}.`)
  }
  request.send(null)

  function response() {
    return {
      ok: (request.status/100|0) == 2,    // 200-299
      json: () => JSON.parse(request.responseText),
      text: () => request.responseText,
    }
  }
  return request
}

export default fetchCallback